import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './browse-by-category.css'

const BrowseByCategory = (props) => {
  return (
    <div className="browse-by-category-container1">
      <Helmet>
        <title>Browse-by-Category - Dogeet</title>
        <meta
          property="og:title"
          content="Browse-by-Category - Dogeet"
        />
        <link
          rel="canonical"
          href="https://dogeet.com/browse-by-category"
        />
      </Helmet>
      <Navigation></Navigation>
      <div className="browse-by-category-container2">
        <div className="browse-by-category-container3">
          <Script
            html={`<style>
input:checked + .search-filters__slider {
  background: var(--color-secondary);
}
input:checked + .search-filters__slider::before {
  transform: translateX(20px);
}
</style>`}
          ></Script>
        </div>
      </div>
      <section className="hero-intro">
        <div className="hero-intro__media">
          <img
            src="https://images.pexels.com/photos/9157304/pexels-photo-9157304.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
            alt="Playful Shiba Inu at the beach"
            className="hero-intro__img"
          />
          <div className="hero-intro__overlay"></div>
        </div>
        <div className="hero-intro__container">
          <div className="hero-intro__content">
            <h1 className="hero-title">
              <span>
                Paws &amp; Play:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
              <span>Everything for Pets</span>
            </h1>
            <p className="hero-subtitle">
              The community bazaar for furry friends, scaled in DOGE. Fetch the
              best local deals without the middle-man bite.
            </p>
            <div className="hero-intro__stats">
              <div className="hero-intro__stat-item">
                <span className="hero-intro__stat-value">1,248</span>
                <span className="hero-intro__stat-label">Active Listings</span>
              </div>
              <div className="hero-intro__stat-item">
                <span className="hero-intro__stat-value">15km</span>
                <span className="hero-intro__stat-label">Local Radius</span>
              </div>
              <div className="hero-intro__stat-item">
                <span className="hero-intro__stat-value">Ð 0.14</span>
                <span className="hero-intro__stat-label">DOGE/USD</span>
              </div>
            </div>
            <div className="hero-intro__actions">
              <a href="#search">
                <div className="btn btn-primary btn-lg">
                  <span>Start Sniffing</span>
                </div>
              </a>
              <a href="#post">
                <div className="btn btn-lg btn-outline">
                  <span>Post for DOGE</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <section id="search" className="search-filters">
        <div className="search-filters__container">
          <div className="search-filters__card">
            <form
              data-form-id="cd65d3be-a590-4b63-98a2-31fe6b026609"
              className="search-filters__form"
            >
              <div className="search-filters__main">
                <div className="search-filters__input-group">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewbox="0 0 24 24"
                    className="search-filters__icon"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <path d="m21 21l-4.34-4.34"></path>
                      <circle cx="11" cy="11" r="8"></circle>
                    </g>
                  </svg>
                  <input
                    type="text"
                    placeholder="Search pet gear, toys, or services..."
                    id="thq_textinput_cURK"
                    name="textinput"
                    data-form-field-id="thq_textinput_cURK"
                    className="search-filters__input"
                  />
                </div>
                <button
                  type="submit"
                  id="thq_button__UHU"
                  name="button"
                  data-form-field-id="thq_button__UHU"
                  className="btn btn-primary"
                >
                  Find Wares
                </button>
              </div>
              <div className="search-filters__grid">
                <div className="search-filters__filter">
                  <label className="search-filters__label">
                    Price Range (DOGE)
                  </label>
                  <div className="search-filters__row">
                    <input
                      type="number"
                      placeholder="Min"
                      id="thq_textinput_WCHt"
                      name="textinput"
                      data-form-field-id="thq_textinput_WCHt"
                      className="search-filters__input-sm"
                    />
                    <input
                      type="number"
                      placeholder="Max"
                      id="thq_textinput_ZHl4"
                      name="textinput"
                      data-form-field-id="thq_textinput_ZHl4"
                      className="search-filters__input-sm"
                    />
                  </div>
                </div>
                <div className="search-filters__filter">
                  <label className="search-filters__label">Distance</label>
                  <select
                    id="thq_select_3EY3"
                    name="select"
                    data-form-field-id="thq_select_3EY3"
                    className="search-filters__select"
                  >
                    <option>Within 5km</option>
                    <option selected="true">Within 15km</option>
                    <option>Within 50km</option>
                    <option>Anywhere</option>
                  </select>
                </div>
                <div className="search-filters__filter">
                  <label className="search-filters__label">Condition</label>
                  <select
                    id="thq_select_2nt-"
                    name="select"
                    data-form-field-id="thq_select_2nt-"
                    className="search-filters__select"
                  >
                    <option>All Conditions</option>
                    <option>New (Unopened)</option>
                    <option>Gently Used</option>
                    <option>Well Loved</option>
                  </select>
                </div>
                <div className="search-filters__filter">
                  <label className="search-filters__label">Delivery</label>
                  <select
                    id="thq_select_Z053"
                    name="select"
                    data-form-field-id="thq_select_Z053"
                    className="search-filters__select"
                  >
                    <option>Any Type</option>
                    <option>Local Pickup</option>
                    <option>Shipping Available</option>
                  </select>
                </div>
              </div>
              <div className="search-filters__footer">
                <div className="search-filters__toggles">
                  <label className="search-filters__switch">
                    <input
                      type="checkbox"
                      checked="true"
                      id="thq_textinput_ofjV"
                      name="textinput"
                      data-form-field-id="thq_textinput_ofjV"
                    />
                    <span className="browse-by-category-thq-search-filtersslider-elm"></span>
                    <span className="search-filters__switch-label">
                      Show USD Reference
                    </span>
                  </label>
                </div>
                <div className="search-filters__sort">
                  <span className="search-filters__label">Sort by:</span>
                  <select
                    id="thq_select_sVzC"
                    name="select"
                    data-form-field-id="thq_select_sVzC"
                    className="search-filters__select-minimal"
                  >
                    <option>Newest First</option>
                    <option>Price: Low to High</option>
                    <option>Price: High to Low</option>
                    <option>Closest First</option>
                  </select>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>
      <section className="explore-listings">
        <div className="explore-listings__container">
          <div className="explore-listings__masonry">
            <div className="explore-listings__item">
              <div className="explore-listings__card">
                <div className="explore-listings__media">
                  <img
                    src="https://images.pexels.com/photos/8926734/pexels-photo-8926734.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                    alt="Dog Goggles"
                    className="explore-listings__img"
                  />
                  <span className="explore-listings__badge">2.4km away</span>
                </div>
                <div className="explore-listings__body">
                  <h3 className="section-subtitle">Doge-Vision Pro Goggles</h3>
                  <div className="explore-listings__price-group">
                    <span className="explore-listings__price-doge">Ð 450</span>
                    <span className="explore-listings__price-usd">
                      ≈ $63.00
                    </span>
                  </div>
                  <div className="explore-listings__actions">
                    <button className="btn btn-primary btn-sm">Contact</button>
                    <button className="btn btn-outline btn-sm">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewbox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="explore-listings__item">
              <div className="explore-listings__card">
                <div className="explore-listings__media">
                  <img
                    src="https://images.pexels.com/photos/14320675/pexels-photo-14320675.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                    alt="Tie-dye harness"
                    className="explore-listings__img"
                  />
                  <span className="explore-listings__badge">0.8km away</span>
                </div>
                <div className="explore-listings__body">
                  <h3 className="section-subtitle">Custom Tie-Dye Harness</h3>
                  <div className="explore-listings__price-group">
                    <span className="explore-listings__price-doge">Ð 180</span>
                    <span className="explore-listings__price-usd">
                      ≈ $25.20
                    </span>
                  </div>
                  <div className="explore-listings__actions">
                    <button className="btn btn-primary btn-sm">Contact</button>
                    <button className="btn btn-outline btn-sm">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewbox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="explore-listings__item">
              <div className="explore-listings__card">
                <div className="explore-listings__media">
                  <img
                    src="https://images.pexels.com/photos/14530403/pexels-photo-14530403.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                    alt="Orange winter coat"
                    className="explore-listings__img"
                  />
                  <span className="explore-listings__badge">5.1km away</span>
                </div>
                <div className="explore-listings__body">
                  <h3 className="section-subtitle">Winter Explorer Puffer</h3>
                  <div className="explore-listings__price-group">
                    <span className="explore-listings__price-doge">Ð 320</span>
                    <span className="explore-listings__price-usd">
                      ≈ $44.80
                    </span>
                  </div>
                  <div className="explore-listings__actions">
                    <button className="btn btn-primary btn-sm">Contact</button>
                    <button className="btn btn-outline btn-sm">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewbox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="explore-listings__item">
              <div className="explore-listings__card">
                <div className="explore-listings__media">
                  <img
                    src="https://images.pexels.com/photos/13062654/pexels-photo-13062654.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                    alt="Pet bed"
                    className="explore-listings__img"
                  />
                  <span className="explore-listings__badge">12km away</span>
                </div>
                <div className="explore-listings__body">
                  <h3 className="section-subtitle">Orthopedic Memory Bed</h3>
                  <div className="explore-listings__price-group">
                    <span className="explore-listings__price-doge">Ð 850</span>
                    <span className="explore-listings__price-usd">
                      ≈ $119.00
                    </span>
                  </div>
                  <div className="explore-listings__actions">
                    <button className="btn btn-primary btn-sm">Contact</button>
                    <button className="btn btn-outline btn-sm">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewbox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="explore-listings__footer">
            <button className="btn btn-lg btn-secondary">
              Load More Wares
            </button>
          </div>
        </div>
      </section>
      <section className="map-showcase">
        <div className="map-showcase__container">
          <div className="map-showcase__card">
            <div className="map-showcase__grid">
              <div className="map-showcase__info">
                <h2 className="section-title">Sniff Out Local Deals</h2>
                <p className="section-content">
                  There are 142 pet-related listings within your immediate
                  neighborhood. Tap the map to see exactly where the good boys
                  are selling their gear.
                </p>
                <div className="map-showcase__stats">
                  <div className="map-showcase__chip">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewbox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                      <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                    <span>12 New Today</span>
                  </div>
                  <div className="map-showcase__chip">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewbox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                    </svg>
                    <span>Low DOGE Fees</span>
                  </div>
                </div>
                <a href="/map">
                  <div className="btn btn-primary">
                    <span>Open Full Map</span>
                  </div>
                </a>
              </div>
              <div className="map-showcase__preview">
                <div className="map-showcase__map-placeholder">
                  <div className="browse-by-category-thq-map-showcasepin-elm1 map-showcase__pin"></div>
                  <div className="browse-by-category-thq-map-showcasepin-elm2 map-showcase__pin"></div>
                  <div className="browse-by-category-thq-map-showcasepin-elm3 map-showcase__pin"></div>
                  <div className="browse-by-category-thq-map-showcasepin-elm4 map-showcase__pin"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="browse-by-category-featured-carousel">
        <div className="featured-carousel__container">
          <div className="featured-carousel__header">
            <h2 className="section-title">Featured Community Picks</h2>
            <p className="section-subtitle">
              Promoted by the community using DOGE. Power-seller approved.
            </p>
          </div>
          <div className="featured-carousel__track">
            <div className="featured-carousel__card">
              <div className="featured-carousel__media">
                <img
                  src="https://images.pexels.com/photos/13062512/pexels-photo-13062512.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Pet service"
                  className="featured-carousel__img"
                />
                <div className="featured-carousel__tag">
                  <span>Promoted</span>
                </div>
              </div>
              <div className="featured-carousel__body">
                <h3 className="section-subtitle">Premium Shiba Grooming</h3>
                <p className="section-content">
                  Full spa day for your energetic friend. Includes claw trim.
                </p>
                <div className="featured-carousel__price">
                  <span>Ð 1,200</span>
                </div>
                <button className="btn btn-secondary btn-sm">
                  View Listing
                </button>
              </div>
            </div>
            <div className="featured-carousel__card">
              <div className="featured-carousel__media">
                <img
                  src="https://images.pexels.com/photos/19369855/pexels-photo-19369855.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Winter gear"
                  className="featured-carousel__img"
                />
                <div className="featured-carousel__tag">
                  <span>Power Seller</span>
                </div>
              </div>
              <div className="featured-carousel__body">
                <h3 className="section-subtitle">All-Weather Leash Set</h3>
                <p className="section-content">
                  Heavy duty, reflective, and chew-proof. DOGE exclusive.
                </p>
                <div className="featured-carousel__price">
                  <span>Ð 250</span>
                </div>
                <button className="btn btn-secondary btn-sm">
                  View Listing
                </button>
              </div>
            </div>
            <div className="featured-carousel__card">
              <div className="featured-carousel__media">
                <img
                  src="https://images.pexels.com/photos/4422098/pexels-photo-4422098.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Pet treats"
                  className="featured-carousel__img"
                />
                <div className="featured-carousel__tag">
                  <span>Trending</span>
                </div>
              </div>
              <div className="featured-carousel__body">
                <h3 className="section-subtitle">Organic Shiba Snacks</h3>
                <p className="section-content">
                  Hand-made treats with zero fillers. Much wow, very taste.
                </p>
                <div className="featured-carousel__price">
                  <span>Ð 80</span>
                </div>
                <button className="btn btn-secondary btn-sm">
                  View Listing
                </button>
              </div>
            </div>
            <div className="featured-carousel__card">
              <div className="featured-carousel__media">
                <img
                  src="https://images.pexels.com/photos/10061684/pexels-photo-10061684.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Pet travel"
                  className="featured-carousel__img"
                />
                <div className="featured-carousel__tag">
                  <span>Promoted</span>
                </div>
              </div>
              <div className="featured-carousel__body">
                <h3 className="section-subtitle">Travel Window Perch</h3>
                <p className="section-content">
                  Let them see the world safely from your car window.
                </p>
                <div className="featured-carousel__price">
                  <span>Ð 410</span>
                </div>
                <button className="btn btn-secondary btn-sm">
                  View Listing
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="how-it-works">
        <div className="how-it-works__container">
          <div className="how-it-works__header">
            <h2 className="section-title">How To Trade Wares</h2>
            <p className="section-subtitle">
              Peer-to-peer. Non-custodial. Pure Dogecoin energy.
            </p>
          </div>
          <div className="how-it-works__steps">
            <div className="how-it-works__step">
              <div className="how-it-works__icon-box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewbox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092a10 10 0 1 0-4.777-4.719"></path>
                </svg>
              </div>
              <h3 className="section-subtitle">1. Sniff &amp; Chat</h3>
              <p className="section-content">
                Find a listing you love and message the seller directly via our
                masked relay.
              </p>
            </div>
            <div className="how-it-works__step">
              <div className="how-it-works__icon-box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewbox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1"></path>
                    <path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="section-subtitle">2. Pay in DOGE</h3>
              <p className="section-content">
                Send DOGE directly to the seller&apos;s wallet. No middle-man
                fees, just pure P2P magic.
              </p>
            </div>
            <div className="how-it-works__step">
              <div className="how-it-works__icon-box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewbox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                  <path d="m9 12l2 2l4-4"></path>
                </svg>
              </div>
              <h3 className="section-subtitle">3. Local Fetch</h3>
              <p className="section-content">
                Meet up in a safe public spot to exchange the wares. Community
                safety first!
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="trust-reviews">
        <div className="trust-reviews__container">
          <div className="trust-reviews__header">
            <h2 className="section-title">Community Bark</h2>
            <p className="section-subtitle">
              Real feedback from the Dogeet pet community.
            </p>
          </div>
          <div className="trust-reviews__carousel">
            <div className="trust-reviews__card">
              <div className="trust-reviews__user">
                <img
                  src="https://images.pexels.com/photos/2187304/pexels-photo-2187304.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Reviewer"
                  className="trust-reviews__avatar"
                />
                <div className="trust-reviews__meta">
                  <span className="trust-reviews__name">ShibaLover99</span>
                  <div className="trust-reviews__rating">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewbox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path>
                    </svg>
                    <span>5.0</span>
                  </div>
                </div>
              </div>
              <blockquote className="trust-reviews__quote">
                <span>
                  &quot;Traded a vintage harness for 200 DOGE. The seller was
                  super friendly and we met at the local park. Much
                  smooth!&quot;
                </span>
              </blockquote>
            </div>
            <div className="trust-reviews__card">
              <div className="trust-reviews__user">
                <img
                  src="https://images.pexels.com/photos/13062502/pexels-photo-13062502.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Reviewer"
                  className="trust-reviews__avatar"
                />
                <div className="trust-reviews__meta">
                  <span className="trust-reviews__name">DogeDad</span>
                  <div className="trust-reviews__rating">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewbox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path>
                    </svg>
                    <span>4.8</span>
                  </div>
                </div>
              </div>
              <blockquote className="trust-reviews__quote">
                <span>
                  &quot;Found a local groomer who accepts Dogecoin! Saved me the
                  hassle of converting to fiat. Fast and easy.&quot;
                </span>
              </blockquote>
            </div>
            <div className="trust-reviews__card">
              <div className="trust-reviews__user">
                <img
                  src="https://images.pexels.com/photos/16574819/pexels-photo-16574819.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  alt="Reviewer"
                  className="trust-reviews__avatar"
                />
                <div className="trust-reviews__meta">
                  <span className="trust-reviews__name">MoonWalker</span>
                  <div className="trust-reviews__rating">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewbox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path>
                    </svg>
                    <span>5.0</span>
                  </div>
                </div>
              </div>
              <blockquote className="trust-reviews__quote">
                <span>
                  &quot;Sold my extra pet carrier in minutes. The community
                  energy here is awesome. To the park!&quot;
                </span>
              </blockquote>
            </div>
          </div>
        </div>
      </section>
      <section className="cta-post">
        <div className="cta-post__container">
          <div className="cta-post__card">
            <div className="cta-post__content">
              <h2 className="section-title">Got Wares to Fetch?</h2>
              <p className="section-content">
                Post your listing in 60 seconds. Reach thousands of local pet
                parents who love DOGE as much as you do. Moderated for a
                friendly bazaar experience.
              </p>
              <div className="cta-post__actions">
                <a href="/post">
                  <div className="btn btn-primary btn-lg">
                    <span>Post Listing Now</span>
                  </div>
                </a>
                <span className="cta-post__note">
                  Featured spots available for Ð 50
                </span>
              </div>
            </div>
            <div className="cta-post__illustration">
              <img
                src="https://images.pexels.com/photos/15837135/pexels-photo-15837135.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                alt="Happy Dog"
                className="cta-post__img"
              />
            </div>
          </div>
        </div>
      </section>
      <div className="browse-by-category-container4">
        <div className="browse-by-category-container5">
          <Script
            html={`<style>
        @keyframes bounce {0%,100% {transform: rotate(-45deg) translateY(0);}
50% {transform: rotate(-45deg) translateY(-10px);}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="browse-by-category-container6">
        <div className="browse-by-category-container7">
          <Script
            html={`<script defer data-name="dogeet-browser">
(function(){
  // Simple intersection observer for scroll reveals
  const observerOptions = {
    threshold: 0.1
  };

  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
      }
    });
  }, observerOptions);

  document.querySelectorAll('.explore-listings__item, .featured-carousel__card, .trust-reviews__card').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'all 0.6s ease-out';
    revealObserver.observe(el);
  });

  // Handle USD Toggle logic
  const usdSwitch = document.querySelector('.search-filters__switch input');
  const usdPrices = document.querySelectorAll('.explore-listings__price-usd');

  if (usdSwitch) {
    usdSwitch.addEventListener('change', (e) => {
      usdPrices.forEach(price => {
        price.style.display = e.target.checked ? 'inline' : 'none';
      });
    });
  }

  // Carousel horizontal scroll snap behavior enhancement
  const tracks = document.querySelectorAll('.featured-carousel__track, .trust-reviews__carousel');
  tracks.forEach(track => {
    let isDown = false;
    let startX;
    let scrollLeft;

    track.addEventListener('mousedown', (e) => {
      isDown = true;
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
    });

    track.addEventListener('mouseleave', () => {
      isDown = false;
    });

    track.addEventListener('mouseup', () => {
      isDown = false;
    });

    track.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - track.offsetLeft;
      const walk = (x - startX) * 2;
      track.scrollLeft = scrollLeft - walk;
    });
  });
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default BrowseByCategory
